export default __webpack_public_path__ + "static/media/headset2.a4f135bb.jfif";